import enseirb from '../assets/enseirb.jpg'
import fenelon from '../assets/fenelon.jpg'
import hust from '../assets/hust.png'
import louiseDeMarillac from '../assets/louise-de-marillac.png'

const educationFiles = [
  {
    "year": "2019",
    "items": [
      {
        "id": 0,
        "name": "Huazhong University of Science and Technology.png",
        "logo": hust,
        "height": "50%",
        "width": "70%",
        "details": [
          {"key": "Name", "value": "Huazhong University of Science and Technology"},
          {"key": "Period", "value": "September 2018 - January 2019"},
          {"key": "Location", "value": "Wuhan, China"},
          {"key": "Type", "value": "Exchange program"},
          {"key": "Link", "value": "http://english.hust.edu.cn/index.htm"},
          {"key": "Description", "value": "Computer Science department. Courses in Big Data Analysis, Artificial Intelligence, Pattern Recognition, Machine Learning, Computer Vision, Digital Image Processing."}
        ]
      },
      {
        "id": 1,
        "name": "ENSEIRB-MATMECA.jpg",
        "logo": enseirb,
        "height": "50%",
        "width": "70%",
        "details": [
          {"key": "Name", "value": "ENSEIRB-MATMECA"},
          {"key": "Period", "value": "September 2016 - August 2019"},
          {"key": "Type", "value": "Master degree"},
          {"key": "Location", "value": "Bordeaux, France"},
          {"key": "Link", "value": "https://enseirb-matmeca.bordeaux-inp.fr/fr"},
          {"key": "Description", "value": "Computer Science specialization."}
        ]
      },
    ]
  },
  {
    "year": "2016",
    "items": [
      {
        "id": 2,
        "name": "Lycée Fénelon.jpg",
        "logo": fenelon,
        "height": "50%",
        "width": "70%",
        "details": [
          {"key": "Name", "value": "Lycée Fénelon"},
          {"key": "Period", "value": "September 2014 - August 2016"},
          {"key": "Type", "value": "French classe préparatoire aux grandes écoles (CPGE)"},
          {"key": "Location", "value": "Paris, France"},
          {"key": "Link", "value": "https://lyc-fenelon.ac-paris.fr/"},
          {"key": "Description", "value": "Intensive preparatory course in order to enroll in a French Grande École. Studied in the MPSI (mathematics, physics and engineering science) track, followed by the MP (mathematics and physics) class."}
        ]
      },
    ]
  },
  {
    "year": "2014",
    "items": [
      {
        "id": 3,
        "name": "Louise-de-Marillac.jpg",
        "logo": louiseDeMarillac,
        "height": "30%",
        "width": "50%",
        "details": [
          {"key": "Name", "value": "Lycée Louise-de-Marillac"},
          {"key": "Period", "value": "September 2011 - August 2014"},
          {"key": "Type", "value": "High School"},
          {"key": "Location", "value": "Paris, France"},
          {"key": "Link", "value": "http://www.rosalie-marillac.com/"},
          {"key": "Description", "value": "Obtained the high school diploma (French baccalauréat) in science major, with honors."}
        ]
      }
    ]
  }
]

export default educationFiles;